import FlushUnsavedCompositions from 'actions/composition/flush_unsaved_compositions';

export default function configureWindowUnloadHandlers(context) {
  window.addEventListener('beforeunload', evt => {
    context.executeAction(FlushUnsavedCompositions, evt);
  });
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_window_unload_handlers.js